import { Box, styled } from "@mui/material";

type StyledCreateQuotePageProps = {};

export const StyledCreateQuotePage = styled(Box)<StyledCreateQuotePageProps>(
  ({ theme }) => ({
    width: "100%",
    paddingTop: "5rem",
    overflowY: "scroll",
    height: "50rem",
    ".quoteWrapper": {
      boxSizing: "border-box",
      padding: "5rem",
      width: "70rem",
      height: "auto",
      minHeight: "100rem",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
      boxShadow: `0px 0px 3px 3px ${theme.contrast.shadowColor}`,
      margin: "auto",
      borderRadius: "10px",
      ".quoteHeader": {
        display: "flex",
      },
      ".quoteData": {
        display: "flex",
        width: "100%",
        borderRadius: "10px",
        flexDirection: "column",
        overflow: "hidden",
        border: `2px solid ${theme.contrast.lighter}`,
        ".head": {
          display: "flex",
          width: "100%",
          background: theme.color.main,
          h4: {
            width: "25%",
            color: theme.color.background,
            height: "3rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
          },
        },
        ".data": {
          display: "flex",
          width: "100%",
          h4: {
            width: "25%",
            height: "3rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            color: theme.contrast.dark,
          },
        },
      },
      ".quoteItems": {
        width: "100%",
        borderRadius: "10px",
        border: `2px solid ${theme.contrast.dark}`,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        button: {
          width: "100%",
          background: theme.contrast.lighter,
          color: theme.color.dark,
        },
        ".head": {
          display: "flex",
          background: theme.color.main,
          height: "2.5rem",
          alignItems: "center",
          h4: {
            color: theme.color.background,
            paddingInline: ".5rem",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          },
          ".position": {
            width: "5%",
          },
          ".description": {
            width: "80%",
            borderLeft: `2px solid ${theme.color.dark}`,
            borderRight: `2px solid ${theme.color.dark}`,
          },
          ".total": {
            width: "15%",
          },
        },
      },
      ".quoteInfo": {
        display: "flex",
        justifyContent: "space-between",
        ".total": {
          width: "20rem",
          border: `2px solid ${theme.color.dark}`,
          borderRadius: "10px",
          overflow: "hidden",
          ".row": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: ".5rem",

            h3: {
              fontWeight: "600",
              letterSpacing: "2px",
            },
          },
          ".totalRow": {
            background: theme.color.dark,
            color: theme.color.background,
          },
        },
        ".paymentTerms": {
          border: "2px solid",
          width: "20rem",
          height: "fit-content",
          borderColor: theme.color.dark,
          borderRadius: "10px",
          ".title": {
            paddingInline: ".5rem",
            fontWeight: "bold",
            textAlign: "end",
            width: "100%",
            boxSizing: "border-box",
          },
          ".row": {
            borderTop: `2px solid ${theme.color.dark}`,
            display: "flex",
            ".column": {
              paddingInline: ".5rem",
              textAlign: "end",
              width: "100%",
            },
            ".number": {
              width: "2rem",
              borderRight: `2px solid ${theme.color.dark}`,
            },
          },
        },
      },
    },
  })
);
